<template>
  <div
    class="cursor-pointer"
    data-qa="club_switch"
    @click="isEnabled = !isEnabled"
  >
    <div class="d-flex align-center gc-3">
      <div
        v-if="discount"
        class="club-price-discount text-subtitle-2"
        data-qa="club_switch_percent"
      >
        -<span data-qa="club_switch_discount">{{ discount }}</span>%
      </div>
      <div
        class="text-subtitle-1 error--text w-100"
        data-qa="club_switch_title"
      >
        {{ title }}
      </div>
      <v-switch
        :value="isEnabled"
        :input-value="isEnabled"
        color="error"
        class="club-switch pt-0 mt-0 pl-1"
        data-qa="club_switch_input"
        hide-details
        dense
        inset
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  value: boolean
  title: string,
  discount?: number | string | null,
}>()

type Emits = {
  (_event: 'input', _value: boolean): void
}

const emit = defineEmits<Emits>()

const isEnabled = computed({
  get() {
    return props.value
  },
  set(value: boolean) {
    emit('input', value)
  },
})
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.club-price-discount {
  background-color: $ui-kit-error;
  background-image: $ui-kit-club-gradient;
  border-radius: $border-radius-sm;
  color: $ui-kit-bg-gray-0;
  padding: 2px 4px;
}
</style>

<style lang="scss">
.club-switch.v-input {
  width: 44px;
  height: 20px;
}
</style>
